import {
  GET_ADMIN_SF_FILTERS,
  GET_ADMIN_SF_FILTERS_SUCCESS,
  GET_ADMIN_SF_FILTERS_ERROR,
  CREATE_ADMIN_SF_FILTER,
  CREATE_ADMIN_SF_FILTER_SUCCESS,
  CREATE_ADMIN_SF_FILTER_ERROR,
  UPDATE_ADMIN_SF_FILTER,
  UPDATE_ADMIN_SF_FILTER_SUCCESS,
  UPDATE_ADMIN_SF_FILTER_ERROR,
  DELETE_ADMIN_SF_FILTER,
  DELETE_ADMIN_SF_FILTER_SUCCESS,
  DELETE_ADMIN_SF_FILTER_ERROR,
} from "./actionTypes"

const INIT_STATE = {
  admin_sf_filters: [],
  error: null,
  loading: false,
}

const AdminSfFilters = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ADMIN_SF_FILTERS:
      return {
        ...state,
        loading: true,
      }
    case GET_ADMIN_SF_FILTERS_SUCCESS:
      return {
        ...state,
        loading: false,
        admin_sf_filters: action.payload,
      }
    case GET_ADMIN_SF_FILTERS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    case CREATE_ADMIN_SF_FILTER:
      return {
        ...state,
        loading: true,
      }
    case CREATE_ADMIN_SF_FILTER_SUCCESS:
      return {
        ...state,
        loading: false,
        admin_sf_filters: [...state.admin_sf_filters, action.payload],
      }
    case CREATE_ADMIN_SF_FILTER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    case UPDATE_ADMIN_SF_FILTER:
      return {
        ...state,
        loading: true,
      }
    case UPDATE_ADMIN_SF_FILTER_SUCCESS:
      return {
        ...state,
        loading: false,
        admin_sf_filters: state.admin_sf_filters.map((admin_sf_filter) => {
          if (admin_sf_filter.id === action.payload.id) {
            return action.payload
          }
          return admin_sf_filter
        }),
      }
    case UPDATE_ADMIN_SF_FILTER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    case DELETE_ADMIN_SF_FILTER:
      return {
        ...state,
        loading: true,
      }
    case DELETE_ADMIN_SF_FILTER_SUCCESS:
      return {
        ...state,
        loading: false,
        admin_sf_filters: state.admin_sf_filters.filter(
          (admin_sf_filter) => admin_sf_filter.id !== action.payload.id
        ),
      }
    case DELETE_ADMIN_SF_FILTER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    default:
      return state
  }
}

export default AdminSfFilters;
